import {
        InMemoryCache,
        ApolloClient,
        createHttpLink,
} from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'

import { offsetLimitPagination } from '@apollo/client/utilities'

import { createApolloProvider } from '@vue/apollo-option'
import { typeDefs } from './typeDefs'

const cache = new InMemoryCache({
        typePolicies: {
                Query: {
                        fields: {
                                CoursePages: offsetLimitPagination(),
                        },
                },
        },
})

const httpLink = createHttpLink({
        uri: import.meta.env.VITE_BACKEND_URL,
        // credentials: 'include', // This is important for including cookies in the request
})

export function getTokenFromLocalStorage() {
        if (typeof window === 'undefined') return null

        try {
                const rawVuex = window.localStorage.getItem('vuex')
                if (!rawVuex) return null

                const parsedVuex = JSON.parse(rawVuex)
                return (
                        parsedVuex?.user?.user?.accessToken ||
                        parsedVuex?.user?.accessToken ||
                        null
                )
        } catch (error) {
                console.warn(
                        '[apollo.provider] Impossible de récupérer le token depuis le localStorage',
                        error
                )
                return null
        }
}

const MASTER_HEADER_VALUE = import.meta.env.VITE_MASTER_HEADER || 'xxxxx'

const authLink = setContext((_, { headers }) => {
        // Récupère le token depuis le localStorage (vuex)
        const token = getTokenFromLocalStorage()

        // Return the headers to the context so httpLink can read them
        return {
                headers: {
                        ...headers,
                        authorization: token ? `Bearer ${token}` : '',
                        please_let_me_master: MASTER_HEADER_VALUE,
                },
        }
})

const apolloClient = new ApolloClient({
        link: authLink.concat(httpLink),
        cache,
        typeDefs,
        resolvers: {},
        defaultOptions: {
                watchQuery: {
                        fetchPolicy: 'cache-and-network',
                        nextFetchPolicy: 'cache-first',
                },
        },
})

export const provider = createApolloProvider({
        defaultClient: apolloClient,
})
